<template>
  <div class="password-form">
    <ul class="pass-group clearfix">
      <li class="item"><input type="text" v-model.number="a" @keyup="onKeyUp" class="form-control" :class="{full:(a + '').length}" maxlength="1" ref="a" data-index="0"></li>
      <li class="item"><input type="text" v-model.number="b" @keyup="onKeyUp" class="form-control" :class="{full:(b + '').length}" maxlength="1" ref="b" data-index="1"></li>
      <li class="item"><input type="text" v-model.number="c" @keyup="onKeyUp" class="form-control" :class="{full:(c + '').length}" maxlength="1" ref="c" data-index="2"></li>
      <li class="item"><input type="text" v-model.number="d" @keyup="onKeyUp" class="form-control" :class="{full:(d + '').length}" maxlength="1" ref="d" data-index="3"></li>
      <li class="item"><input type="text" v-model.number="e" @keyup="onKeyUp" class="form-control" :class="{full:(e + '').length}" maxlength="1" ref="e" data-index="4"></li>
      <li class="item"><input type="text" v-model.number="f" @keyup="onKeyUp" class="form-control" :class="{full:(f + '').length}" maxlength="1" ref="f" data-index="5"></li>
    </ul>
  </div>
</template>

<script type="text/javascript">
  export default {
    props: {
      start: Boolean
    },
    data () {
      return {
        a: '',
        b: '',
        c: '',
        d: '',
        e: '',
        f: ''
      }
    },
    watch: {
      start (val) {
        let keys = ['a', 'b', 'c', 'd', 'e', 'f']
        keys.forEach((key) => {
          this[key] = ''
        })
        if (val) {
          this.$nextTick(() => {
            this.$refs.a.focus()
          })
        }
      }
    },
    methods: {
      onKeyUp (e) {
        let keyCode = e.keyCode
        let keys = ['a', 'b', 'c', 'd', 'e', 'f']
        let index = e.target.getAttribute('data-index') - 0
        if (keyCode === 8 || keyCode === 46 || keyCode === 13 || (keyCode >= 48 && keyCode <= 57) || (keyCode >= 96 && keyCode <= 105)) {
          let model = this[keys[index]] + ''
          if (keyCode === 8 || keyCode === 46) {
            if (!model.length) {
              if (index === 0) {
                this.$emit('clear')
              } else {
                this.$refs[keys[index - 1]].focus()
              }
            }
          } else {
            if (model.length) {
              if (index === 5) {
                let result = keys.map((key) => this[key]).join('')
                this.$emit('done', result)
              } else {
                this.$refs[keys[index + 1]].focus()
              }
            }
          }
        } else {
          this[keys[index]] = ''
        }
      }
    }
  }
</script>

<style lang="stylus" scoped>
  .password-form
    width 580px
    padding 20px 25px
    .pass-group
      display table
      margin 0
      padding 0
      list-style-type none
      table-layout fixed
      .item
        display table-cell
        padding 0 14px
        text-align center
        .form-control
          display inline-block
          width 60px
          height 60px
          padding 0
          font-size 28px
          line-height 60px
          text-align center
          border 1px solid rgb(213,213,213)
          &.full
            border-color rgb(70, 209, 255)
</style>



// WEBPACK FOOTER //
// password-input.vue?e9dbe5ac